module.exports = __webpack_public_path__ + "img/fish_squid.48a95b93.png";